export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/flyer_design.c80615b.svg";